import PropTypes from 'prop-types'
import glamorous from 'glamorous'
import { COLORS } from 'config'

const Indicator = glamorous.div(({ isActive }) => ({
  width: 12,
  height: 12,
  borderRadius: '50%',
  backgroundColor: isActive ? COLORS.white : 'rgba(200, 200, 200, 0.5)'
}))

Indicator.propTypes = {
  isActive: PropTypes.bool
}

Indicator.defaultProps = {
  isActive: false
}

export default Indicator



// WEBPACK FOOTER //
// ./src/components/cards/Indicator.js